import { Outlet, useLoaderData } from "react-router-dom";

import AppWrapper from "../../../../components/cm/AppWrapper";
import TabClientNotesCallLog from "../../../../components/cm/Dashboard/FullPages/ClientDetail/TabClientNotesCallLog";
import SideBarMain from "../../../../components/cm/SideBarMain";

export default () => {
  const { _case, notesList, showMoreCaseNotes } = useLoaderData();

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div className="grid w-auto min-w-[800px] grid-cols-[70%_30%] gap-4">
        <div className="mt-6 rounded-xl bg-white">
          <Outlet />
        </div>
        <TabClientNotesCallLog
          caseObj={_case}
          canViewFollowUps={false}
          canViewNotes
          canViewCallLog={false}
          notesList={notesList}
          showMoreCaseNotes={showMoreCaseNotes}
        />
      </div>
    </AppWrapper.WithSidebar>
  );
};
